import { render, staticRenderFns } from "./VSlidesCorrectors.vue?vue&type=template&id=219fdb57"
import script from "./VSlidesCorrectors.vue?vue&type=script&lang=js"
export * from "./VSlidesCorrectors.vue?vue&type=script&lang=js"
import style0 from "./VSlidesCorrectors.vue?vue&type=style&index=0&id=219fdb57&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports